module.exports = __webpack_public_path__ + "app/principal/modals/modal-delete-container-1UtrjdbD.html";